import { render, staticRenderFns } from "./NoticeSlider.vue?vue&type=template&id=afe27d68&scoped=true&"
import script from "./NoticeSlider.vue?vue&type=script&lang=ts&"
export * from "./NoticeSlider.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeSlider.vue?vue&type=style&index=0&id=afe27d68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe27d68",
  null
  
)

export default component.exports